/**
 * Development-only console helpers. No-op in production builds.
 * Call sites still evaluate arguments — use only for cheap values.
 */

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

export function devLog(...args) {
  if (isDev()) console.log(...args);
}

export function devWarn(...args) {
  if (isDev()) console.warn(...args);
}

const devLogApi = { devLog, devWarn };
export default devLogApi;
